import React from 'react';
import { Typography, Box } from '@mui/material';

import { EmptyIcon } from 'icons';

import { useStyles } from './styles';

interface EmptyPageProps {
  description: string;
  title?: string;
  icon?: boolean;
}

const EmptyPage = (props: EmptyPageProps) => {
  const { icon, title, description } = props;
  const { classes } = useStyles();

  return (
    <Box mt={4} mb={4} className={classes.emptyWrap}>
      {icon && <EmptyIcon className={classes.emptyIcon} />}
      <Typography variant="h3" className={classes.emptyTitle}>
        {title}
      </Typography>
      <Typography variant="subtitle1">{description}</Typography>
    </Box>
  );
};

EmptyPage.defaultProps = {
  icon: true,
  title: "Ouhh…it's empty in here.",
};

export default EmptyPage;
